import React, { lazy, Suspense } from 'react';

const LazyPreviousOrderCart = lazy(() => import('./PreviousOrderCart'));

const PreviousOrderCart = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyPreviousOrderCart {...props} />
  </Suspense>
);

export default PreviousOrderCart;
